const generateUUID = () => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

const getSessionValue = () => {
  let sessionString = window.localStorage.getItem('mic-session')
  if (!sessionString || sessionString.trim().length === 0) {
    sessionString = generateUUID()
    window.localStorage.setItem('mic-session', sessionString)
  }
  return sessionString
}

const regenerateSession = () => {
  const sessionString = generateUUID()
  window.localStorage.setItem('mic-session', sessionString)
  return sessionString
}

export { getSessionValue, regenerateSession }
